import React, { useEffect, useState } from 'react';
import { Header1 } from '../../BabyNameFinder/NameMeaning/NameAlsoLike/styled';
import { SVGHeader } from '../../../Svg/Header';
import { useRouter } from 'next/router';
import TypicalComponent from './Typical';
import { clickedSearchTabEvent } from '../../Search/instrumentation';

function DesktopSearch(props) {
  const {
    handleInputChange,
    setShowSearchSectionClass,
    searchString,
    showSearchResultHandler,
    searchBoxRef,
    changeToSearchRoute,
    //trendingSearchData,
  } = props;
  const [searchsvg, setSearchSvg] = useState('searchblacknew');
  const [showInput, setShowInput] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const router = useRouter();

  const onBlurHandler = (e) => {
    const element = document.getElementById('searchContainer');
    if (element) {
      element.className = 'iconSection';
    }

    setShowSearchSectionClass(false);
    setSearchSvg('searchblacknew');
    setShowInput(false);
  };

  useEffect(() => {
    setShowSearchSectionClass(false);
    onBlurHandler();
  }, [router.query.q]);

  useEffect(() => {
    setIsClient(true);
    document.body.onclick = (event) => {
      searchBoxRef.current
        ? (searchBoxRef.current.style.display = 'none')
        : null;
      onBlurHandler(event);
      document.body.classList.remove('noScroll');
    };

    return () => document.body.removeAttribute('onclick');
  }, []);

  const inputClickHandler = (e) => {
    e.stopPropagation();
    clickedSearchTabEvent();
    setShowInput(true);
    setTimeout(() => {
      setShowSearchSectionClass(true);
      document.getElementById('searchInput')?.focus();
    }, 0);
  };

  const onFocusHandler = () => {
    document.getElementById('searchContainer').className = 'iconSectionFocus';
    setSearchSvg('searchWhite');
  };
  const trendingSearchData = [
    'Baby Diaper Pants',
    'Baby Wipes',
    'Stretch Marks',
    'Baby Carrier',
  ];

  if (!isClient) {
    return null;
  }

  return (
    <>
      <div>
        {!showInput && trendingSearchData?.length > 0 && (
          <div className="typicalStyle" onClick={inputClickHandler}>
            <TypicalComponent trendingSearchData={trendingSearchData} />
          </div>
        )}

        {showInput && (
          <form onSubmit={(e) => changeToSearchRoute(e, searchString)}>
            <input
              type="text"
              placeholder=""
              onChange={handleInputChange}
              onClick={showSearchResultHandler}
              id="searchInput"
              autoComplete="off"
              value={searchString}
              onFocus={onFocusHandler}
            />
          </form>
        )}
      </div>

      <Header1>
        <div
          onClick={(e) => {
            !showInput
              ? inputClickHandler(e)
              : changeToSearchRoute(e, searchString);
          }}
          className="iconSection"
          id="searchContainer"
        >
          <SVGHeader id={searchsvg} />
        </div>
      </Header1>
    </>
  );
}

export default DesktopSearch;
